import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Validators, FormGroup, FormControl, FormBuilder } from "@angular/forms";
import { LoginObject } from "../auth/login-object.model";
import { Session } from "../auth/session.model";
import { AuthService } from "../auth/auth.service";
import { StorageService } from "../auth/storage.service";
import { MenuService } from '../core/menu/menu.service';
import { MessagesService } from "../messages.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public loading : boolean;
  public loginForm: FormGroup;
  public submitted: Boolean = false;

  constructor(private fb: FormBuilder,
              private authService: AuthService,
              private storageService: StorageService,
              private router: Router,
              private menuService : MenuService,
              private messagesService : MessagesService) { }

  ngOnInit() {
    this.storageService.removeCurrentSession();
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    })
  }

  public submitLogin(): void {
    this.loading = true;
    this.submitted = true;
    if(this.loginForm.valid){
      this.authService.login(new LoginObject(this.loginForm.value)).subscribe(
        data  => { this.loading = false; this.correctLogin(data) },
        error => { this.loading = false; this.messagesService.viewError('Usuario o contraseña inválido.'); }
      )
    } else {
        this.loading = false;
    }
  }

  private correctLogin(data){
    let session = new Session();
    session.token = data.token.access_token;
    session.user = {  accountId: data.account_id, email: this.loginForm.value.username, firstName: data.user_data.firstname , lastName: data.user_data.lastname };
    session.menu = data.list_operations;
    this.storageService.setCurrentSession(session);
    this.menuService.fillMenu(session.menu);
    this.router.navigate(['/home']);
  }
}
